import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { SearchCard } from "../components/SearchCard";
import { Logo } from "../components/Logo";
import { useSiteImages } from "../context/SiteImagesContext";
import { Loader, EmptyState } from "../components/ui-bits";
import { Search } from "lucide-react";

export default function StartBeatmaker() {
  const nav = useNavigate();
  const { img } = useSiteImages();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/searches/public-feed").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return (
    <div className="min-h-screen">
      <header className="glass border-b border-zinc-800/70 sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between">
          <Logo />
          <button onClick={() => nav("/register?role=beatmaker")} data-testid="beatmaker-signup-cta"
            className="text-sm font-semibold px-4 py-2 rounded-xl btn-primary text-white">Créer mon compte</button>
        </div>
      </header>
      <div className="relative max-w-5xl mx-auto px-4 py-8">
        <div className="pointer-events-none absolute -top-6 right-0 w-72 h-72 rounded-full blur-[110px] opacity-30"
          style={{ backgroundImage: `url(${img("artwork_beatmaker")})`, backgroundSize: "cover" }} />
        <h1 className="relative font-display font-extrabold text-3xl sm:text-4xl tracking-tight mb-1">RECHERCHES POUR TOI</h1>
        <p className="text-sm text-zinc-400 mb-7">
          Choisis une recherche et propose tes 3 prods.{" "}
          <button onClick={() => nav("/register?role=beatmaker")} className="text-violet-300 font-medium hover:text-violet-200">Crée ton compte →</button>
        </p>
        {items === null ? <Loader /> : items.length === 0 ? (
          <EmptyState icon={Search} title="Aucune recherche pour l'instant" desc="Reviens bientôt, de nouvelles recherches arrivent." />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((s) => <SearchCard key={s.id} search={s} ctaLabel="Proposer" onClick={() => nav(`/r/${s.code}`)} />)}
          </div>
        )}
      </div>
    </div>
  );
}
